import { ZERO_UUID } from 'commons/constants/parse.js';

export const state = (mockContent) => ({
    ...mockContent,
});

export const getContent = (content_id) => ({
    content_id,
    container_uuid: ZERO_UUID,
    actor_uuid: ZERO_UUID,
    parent_content_uuid: ZERO_UUID,
    content: '',
    date_created: Date.now(),
    date_updated: Date.now(),
    processing_status: undefined,
    ip: undefined,
    tags: [],
    raw_page_url: '',
    searchable_page_url: '',
    media: [],
    site_uuid: ZERO_UUID,
    section_uuid: ZERO_UUID,
    service: undefined,
    actions: [],
    origin: '',
    editor_pick: false,
    // content_context_options: {},
    have_tags_changed: false,
    is_bulk_selected: false,
    client_uuid: ZERO_UUID,
    language: 'en',
    is_top_comment: null,
    is_top_comment_eligible_by_mod: null,
});
